exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.chapter-container[data-v-7ab42238] {\n  width: 80%;\n  height: 8vw;\n  border: solid 1px black;\n  margin-top: 1vw;\n  margin-bottom: 2vw;\n  margin-left: 1vw;\n  opacity: 1;\n}\n.list-container[data-v-7ab42238] {\n  display: block;\n  position: absolute;\n  left: 0px;\n  top: 0px;\n  height: 90%;\n  width: 15vw;\n  overflow-y: auto;\n  background-color: #0a0a0adc;\n  /* opacity: 0.8; */\n}\n.close-button[data-v-7ab42238] {\n  position: fixed;\n  left: 16vw;\n  top: 1vw;\n}\n", ""]);

// exports
